import React from 'react';
import styled from 'styled-components/macro';

import ResultsList, {
  IEntity,
} from 'components/search/ResultsSection/ResultsList/ResultsList';
import SearchResultsLoader from 'components/utility/ContentLoader/SearchResultsLoader/SearchResultsLoader';

import { ReactComponent as SearchIcon } from 'icons/icon-search.svg';

import { Heading } from 'components/search/ResultsSection/ResultsSection.style';
import { IEntityInfo } from 'pages/Search';
import Box from 'components/elements/Box';

export const NoRecentEntitiesWrapper = styled('div')`
  margin: ${({ theme }): string => theme.spacing.huge} 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h3,
  p,
  svg {
    margin: 0;
    color: ${({ theme }): string => theme.CasperGrey};
    font-weight: normal;
    text-align: center;
    max-width: 100%;
  }

  p {
    margin-top: ${({ theme }): string => theme.spacing.small};
  }

  svg {
    margin-bottom: ${({ theme }): string => theme.spacing.small};
  }
`;
interface IRecentEntitiesProps {
  data?: IEntity[];
  loading?: boolean;
  onAddToListClick: (entityInfo: IEntityInfo) => void;
  onOpenEntity?: (entityInfo: IEntity) => void;
}
/**
 * Conditionally render the recent entities based on the DataFetcher's
 * loading state, and whether there are any recent entities.
 */
const RecentEntities: React.FC<IRecentEntitiesProps> = ({
  data,
  onAddToListClick,
  onOpenEntity,
  loading = false,
}) => (
  <>
    {loading && !data && (
      <>
        <Heading>Recents</Heading>
        <SearchResultsLoader />
      </>
    )}

    {data && data.length === 0 && (
      <NoRecentEntitiesWrapper>
        <SearchIcon />
        <h3>Discover Opus</h3>
        <p>Search any track, release, project, artist or label.</p>
      </NoRecentEntitiesWrapper>
    )}

    {data && data.length > 0 && (
      <>
        <Box
          display="flex"
          justifyContent="flex-start"
          alignItems="flex-start"
          alignContent="stretch"
        >
          <Box alignSelf="auto" flex={0}>
            <Heading>Recents</Heading>
          </Box>
          <Box alignSelf="auto" flex={0} marginLeft="auto" minWidth="5em">
            <Heading>Add to list</Heading>
          </Box>
        </Box>
        <ResultsList
          data={data}
          onAddToListClick={onAddToListClick}
          onOpenEntity={onOpenEntity}
        />
      </>
    )}
  </>
);

/** @component */
export default RecentEntities;
